import { Button, Popconfirm } from "antd";
import Title from "antd/es/typography/Title";
import React, { useEffect, useState } from "react";
import { PaymentInstrument } from "../../../../generated";
import { PaymentInstrumentDisplay } from "../../payment/payment-instrument-display";
import {UpdateCardModalContainer} from '../../../layouts/applicant/components/update-card-modal.container';
import { Country } from "../../../../types/country";
interface PaymentRequestFormProps {
  countries: Country[];
  cyberSourcePublicKey: string;
  applicantId: string;
  paymentInstrument: PaymentInstrument;
  amount: number;
  reason: string;
  message: {
    id: string;
    message: string | null | undefined;
    sentBy: string | null | undefined;
  };
  adhocTransactionId: string;
  adhocPaymentType: string;
  completed: boolean;
  caseId: string;
  onSave: (data: { id: string; messages: { id: string; embedding: string; }[] }) => Promise<void>;
  startPollingMessages: (interval: number) => void;
  pollingMessagesData: { data: { id: string, messages: { id?: string; sentBy?: string; message?: string; embedding?: string }[] }};
  stopPollingMessages: () => void;
}

export const PaymentRequestForm: React.FC<PaymentRequestFormProps> = (props) => {
  const [completed, setCompleted] = useState(props.completed);
  const [isPolling, setIsPolling] = useState(false);
  const [messagesLength, setMessagesLength] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isPolling === true && props.pollingMessagesData.data.messages.length > messagesLength) {
      props.stopPollingMessages();
      setIsPolling(false);
      console.log('polling stop due to message received')
    }
  }, [props.pollingMessagesData]);

  const createInputObject = (message: any, approved: boolean) => {
    const baseInput = {
      id: props.caseId,
      messages: [{
        id: message.id,
        sentBy: message.sentBy,
        message: message.message,
        embedding: JSON.stringify([{
          adhocPayment: {
            amount: props.amount,
            reason: props.reason,
            adhocPaymentType: props.adhocPaymentType,
          },
          adhocTransactionId: props.adhocTransactionId,
          value: "requestPayment",
          completed: true
        }]),
      }],
    };
  
    const transactionApproval = {
      id: props.adhocTransactionId,
      approval: {
        isApplicantApproved: approved,
      },
    };
  
    return {
      ...baseInput,
      financeDetails: {
        transactions: {
          adhocTransactions: [transactionApproval],
        },
      },
      ...(approved && {
        adhocPayment: {
          adhocTransactionId: props.adhocTransactionId,
          amount: props.amount,
          reason: props.reason,
          adhocPaymentType: props.adhocPaymentType,
        },
      }),
    };
  };

  const updateMessage = async (approved: boolean) => {
    const input = createInputObject(props.message, approved);
    await props.onSave(input);
    if (approved === true) {
      // start polling for messages array on 1 second interval and timeout after 5 seconds.
      setMessagesLength(props.pollingMessagesData.data.messages.length);
      props.startPollingMessages(1000);
      setIsPolling(true);
      console.log('polling started')
      // set timeout to stop polling after 5 seconds
      setTimeout(() => {
        props.stopPollingMessages();
        setIsPolling(false);
        console.log('polling stop due to timeout')
      }, 5000);
    }
  };

  const rejectPayment = async () => {
    await updateMessage(false);
    setCompleted(true);
  };

  const sendPayment = async () => {
    await updateMessage(true);
    setCompleted(true);
  };

  const actionButton = (
    <Button type="primary"  style={{ paddingLeft: '5px', paddingRight: '5px', display: 'block', margin: '0 auto', textAlign: 'center' }} onClick={() => setIsOpen(true)}>
      Update card Info
    </Button>
  );

  return (
    <div
      style={{
        backgroundColor: "white",
        paddingTop: "20px",
        paddingBottom: "20px",
        paddingLeft: "20px",
        paddingRight: "20px",
        margin: 10,
        textAlign: "left",
        border: "1px solid #d9d9d9",
        borderRadius: "8px",
      }}
    >
            <div>
        <Title
          level={5}
          style={{
            marginBottom: 15,
          }}
        >
          Payment Requested
        </Title>
        US${props.amount} - {props.adhocPaymentType} Fee - {props.reason}
        <br></br>
        Your credit card will be charged US${props.amount} if you approve this request. If you reject this request, your credential will be sent via standard postal service.
        <br></br>
        <br></br>
        {props.paymentInstrument && (
          <>
            <PaymentInstrumentDisplay paymentInstrument={props.paymentInstrument} actionButton={actionButton} />
            <UpdateCardModalContainer
              applicantUserId={props.applicantId}
              cyberSourcePublicKey={props.cyberSourcePublicKey}
              countries={props.countries}
              paymentInstrumentId={props.paymentInstrument.paymentInstrumentId}
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
            />
          </>
        )}
        <br></br>
        <br></br>
        <div className="flex flex-col lg:flex-row items-center rounded-lg bg-white w-full justify-between overflow-auto">
          <Button type={'primary'} className="mt-3 ms:w-1/4 md:mr-1 lg:mx-4 justify-left" danger ghost onClick={rejectPayment} disabled={completed}>
            Reject Request
          </Button>
            <Popconfirm
            title="Are you sure?"
            onConfirm={sendPayment}
            okText="Yes"
            cancelText="No"
            >
            <Button type={'primary'} className="mt-3 w-1/ lg:mx-4 md:ml-1 justify-right text-overflow" disabled={completed}>
              Approve Payment
            </Button>
            </Popconfirm>
        </div>
      </div>
    </div>
  );
};